var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenProject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-289 381 32 32",
    style: {
      enableBackground: "new -289 381 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BFECCB;}\n\t.st1{fill:#28AB5F;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-262,404.6v-12.4c0-1.5-1.2-2.7-2.7-2.7h-11.4c-0.8,0-1.6-0.4-2.1-1.1l-0.5-0.7c-0.6-0.6-1.4-1-2.2-1h-3.9 c-1.5,0-2.7,1.2-2.7,2.7v15.3c0,1.5,1.2,2.7,2.7,2.7h20.1C-263.2,407.3-262,406.1-262,404.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-264.7,408.1h-20.1c-1.9,0-3.4-1.5-3.4-3.4v-15.3c0-1.9,1.5-3.4,3.4-3.4h3.9c1.1,0,2.1,0.5,2.7,1.4l0.6,0.6 c0.4,0.5,0.9,0.8,1.5,0.8h11.4c1.9,0,3.4,1.5,3.4,3.4v12.4C-261.3,406.5-262.8,408.1-264.7,408.1z M-284.8,387.4 c-1.1,0-1.9,0.9-1.9,1.9v15.3c0,1.1,0.9,1.9,1.9,1.9h20.1c1.1,0,1.9-0.9,1.9-1.9v-12.4c0-1.1-0.9-1.9-1.9-1.9h-11.4 c-1.1,0-2.1-0.5-2.7-1.4l-0.6-0.7c-0.4-0.5-0.9-0.8-1.5-0.8H-284.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-283.6,394.9l-2.8,8.9c-0.5,1.7,0.7,3.5,2.5,3.5h19.9c1.2,0,2.2-0.8,2.5-1.9l2.8-8.9 c0.5-1.7-0.7-3.5-2.5-3.5H-281C-282.2,393-283.2,393.8-283.6,394.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-264,408.1h-19.8c-1.1,0-2.1-0.5-2.8-1.4c-0.7-0.9-0.8-2-0.5-3.1l2.8-8.9c0.5-1.4,1.8-2.4,3.3-2.4h19.8 c1.1,0,2.1,0.5,2.8,1.4c0.7,0.9,0.8,2,0.5,3.1l-2.8,8.9C-261.2,407.1-262.5,408.1-264,408.1z M-281,393.8c-0.8,0-1.6,0.5-1.8,1.3 l-2.8,8.9c-0.2,0.6-0.1,1.2,0.3,1.7c0.4,0.5,0.9,0.8,1.6,0.8h19.7c0.8,0,1.6-0.5,1.8-1.3l2.8-8.9c0.2-0.6,0.1-1.2-0.3-1.7 c-0.4-0.5-0.9-0.8-1.6-0.8C-261.3,393.8-281,393.8-281,393.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenProject);
export default __webpack_public_path__ + "static/media/open_project.18e8e8db19f73cefcbfc826ce03e0654.svg";
export { ForwardRef as ReactComponent };